import {post, get, put, del} from '@/api/request.js'

const url = '/admin/model/cueword'
/**
 * 获取模型关键字
 * @param page{number} 页数
 * @param page_size{number} 每页数量
 * @param key{string} 查询关键字
 * @returns {Promise<void>}
 */
export const get_model_cue_word = async function (page = 1, page_size = 10, key = '') {
    return await get(url, {
        params: {
            page, page_size, key
        }
    })
}

/**
 * 创建模型关键字
 * @param name{string} 替换文本
 * @param content{string} 正则表达式
 * @returns {Promise<AxiosResponse<any>>}
 */
export const create_model_cue_word = async function (name, content) {
    return await post(url, {
        data: {
            name, content
        }
    })
}

/**
 * 修改模型关键字
 * @param name{string} 替换文本
 * @param content{string} 正则表达式
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const edit_model_cue_word = async function (name, content, id) {
    return await put(url, {
        data: {
            name, content
        },
        params: {
            id
        }
    })
}

/**
 * 删除模型关键字
 * @param id{number} id
 * @returns {Promise<AxiosResponse<any>>}
 */
export const delete_model_cue_word = async function (id) {
    return await del(url, {
        params: {
            id
        }
    })
}